import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import GLOBALVAR from "../constants";
import ToPeso from "../components/misc/ToPeso";

function InvestmentPayable() {
    const [fullName, setFullName] = useState("");
    const [startDate, setStartDate] = useState("");
    const [amount, setAmount] = useState("");
    const [interest, setInterest] = useState("");
    const [responseMessage, setResponseMessage] = useState({ type: "", text: "" });
    const [remarks, setRemarks] = useState("");
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const fetchRecords = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${GLOBALVAR["SERVER_ROOT"]}/api/investment-payable`);
            setRecords(res.data && res.data.data ? res.data.data : []);
        } catch (err) {
            setResponseMessage({ type: "error", text: "Failed to fetch records." });
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchRecords();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!fullName || !startDate || !amount || !interest) {
            setResponseMessage({ type: "error", text: "All fields are required." });
            return;
        }
        try {
            await axios.post(`${GLOBALVAR["SERVER_ROOT"]}/api/investment-payable`, {
                full_name: fullName,
                start_date: startDate,
                amount,
                interest_per_month: interest,
                remarks,
            });
            setResponseMessage({ type: "success", text: "Investment payable record added successfully." });
            setFullName("");
            setStartDate("");
            setAmount("");
            setInterest("");
            setRemarks("");
            fetchRecords();
        } catch (err) {
            setResponseMessage({ type: "error", text: "Failed to add record." });
        }
    };

    // Pagination logic
    const totalPages = Math.ceil(records.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = records.slice(startIndex, endIndex);

    return (
        <>
            <NavMain slug="investment-payable" parent="7" />
            <HeaderMain slug="investment-payable" />
            <div className="main-content financials">
                <h4 className="mb-4">Add Investment Payable</h4>
                <div className="card shadow-sm border-0 mb-4 p-0" style={{maxWidth: 900, margin: '0 auto'}}>
                    <form onSubmit={handleSubmit} className="p-4 bg-light rounded">
                        <div className="row g-3 mb-2 align-items-end">
                            <div className="col-md-3">
                                <label className="form-label">Full Name</label>
                                <input
                                    type="text"
                                    className="form-control form-control-lg"
                                    style={{height: 48}}
                                    value={fullName}
                                    onChange={e => setFullName(e.target.value)}
                                    required
                                    placeholder="Enter full name"
                                />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Start Date</label>
                                <input
                                    type="date"
                                    className="form-control form-control-lg"
                                    style={{height: 48}}
                                    value={startDate}
                                    onChange={e => setStartDate(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Amount</label>
                                <input
                                    type="number"
                                    className="form-control form-control-lg"
                                    style={{height: 48}}
                                    value={amount}
                                    onChange={e => setAmount(e.target.value)}
                                    required
                                    min="0"
                                    placeholder="Enter amount"
                                />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Interest % / Month</label>
                                <input
                                    type="number"
                                    className="form-control form-control-lg"
                                    style={{height: 48}}
                                    value={interest}
                                    onChange={e => setInterest(e.target.value)}
                                    required
                                    min="0"
                                    step="0.01"
                                    placeholder="e.g. 1.7"
                                />
                            </div>
                        </div>
                        <div className="row g-3 mt-1 align-items-end">
                            <div className="col-md-9">
                                <label className="form-label">Remarks</label>
                                <textarea
                                    className="form-control form-control-lg"
                                    style={{height: 48}}
                                    value={remarks}
                                    onChange={e => setRemarks(e.target.value)}
                                    placeholder="Add remarks (optional)"
                                    rows={1}
                                />
                            </div>
                            <div className="col-md-3 d-flex align-items-end justify-content-end">
                                <button type="submit" className="btn btn-primary px-4 w-100" style={{height: 48}}>
                                    Submit
                                </button>
                            </div>
                        </div>
                        {responseMessage && responseMessage.text && (
                            <div className={`alert mt-3 ${responseMessage.type === "success" ? "alert-success" : "alert-danger"}`}>
                                {responseMessage.text}
                            </div>
                        )}
                    </form>
                </div>
                <h5 className="mb-3">Investment Payable Records</h5>
                {loading ? (
                    <div>Loading...</div>
                ) : currentItems.length > 0 ? (
                    <div className="card shadow-sm border-0 mb-4">
                        <div className="table-responsive">
                            <table className="list-container table-striped table-hover align-middle mb-0 table" responsive="true">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-center">#</th>
                                        <th>Full Name</th>
                                        <th>Start Date</th>
                                        <th className="text-end">Amount</th>
                                        <th className="text-end">Interest % / Month</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.map((rec, idx) => (
                                        <tr key={rec.id || idx} style={{height: '72px'}}>
                                            <td className="text-center fw-bold" style={{verticalAlign: 'middle', paddingTop: '22px', paddingBottom: '22px'}}>{rec.id || startIndex + idx + 1}</td>
                                            <td style={{minWidth: '200px', paddingTop: '18px', paddingBottom: '18px'}}>
                                                <span className="fw-semibold" style={{fontSize: '1.12em', lineHeight: 1.3}}>{rec.full_name}</span>
                                            </td>
                                            <td style={{verticalAlign: 'middle', paddingTop: '22px', paddingBottom: '22px'}}>{rec.start_date}</td>
                                            <td className="text-end" style={{verticalAlign: 'middle', paddingTop: '22px', paddingBottom: '22px', fontWeight: 600, fontSize: '1.13em'}}><ToPeso amount={rec.amount} /></td>
                                            <td className="text-end" style={{verticalAlign: 'middle', paddingTop: '22px', paddingBottom: '22px', fontWeight: 600, fontSize: '1.13em'}}>{rec.interest_per_month}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <nav className="mt-4 mb-2">
                            <ul className="pagination justify-content-end gap-2 mb-0" style={{fontSize: '1.08em'}}>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <li
                                        key={i + 1}
                                        className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                        style={{marginLeft: 4, marginRight: 4}}
                                        onClick={() => setCurrentPage(i + 1)}
                                    >
                                        <button className="page-link px-3 py-2" style={{borderRadius: 8, minWidth: 38}}>{i + 1}</button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                ) : (
                    <div className="alert alert-info">No investment payable records found.</div>
                )}
            </div>
        </>
    );
}

export default InvestmentPayable;
